import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SeriviciogenericoService {

  constructor() { }

uploadProgress=0


}
